// src/pages/ResetPasswordPage.js

import React, { useState } from 'react';
import { useParams, useNavigate, Link as RouterLink } from 'react-router-dom';
import { Box, Button, TextField, Typography, Paper, Alert, Link } from '@mui/material';
import api from '../services/api';

const ResetPasswordPage = () => {
  const { token } = useParams(); 
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('As senhas não coincidem.');
      return;
    }
    setError('');
    setSuccess('');
    setIsLoading(true);

    try {
      await api.post('/password-reset/confirm/', {
        token: token,
        password: password,
      });
      setSuccess('Senha redefinida com sucesso! Você será redirecionado para o login.');
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.response?.data?.password?.[0] || 'Token inválido ou expirado.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: 'linear-gradient(to bottom, #F2F5F8, #E6EDF4)' }}>
      <Paper component="form" onSubmit={handleSubmit} elevation={6} sx={{ padding: 4, width: 400, textAlign: 'center' }}>
        <Typography variant="h5" sx={{ marginY: 2, color: '#0D47A1' }}>Crie sua Nova Senha</Typography>
        
        {error && <Alert severity="error" sx={{ my: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ my: 2 }}>{success}</Alert>}

        <TextField fullWidth label="Nova Senha" type="password" value={password} onChange={(e) => setPassword(e.target.value)} margin="normal" required />
        <TextField fullWidth label="Confirmar Nova Senha" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} margin="normal" required />
        
        <Button type="submit" fullWidth variant="contained" sx={{ mt: 2, py: 1.5, backgroundColor: '#1565C0' }} disabled={isLoading}>
          {isLoading ? 'Salvando...' : 'Redefinir Senha'}
        </Button>
      </Paper>
    </Box>
  );
};

export default ResetPasswordPage;